import { themr } from '@friendsofreactjs/react-css-themr';

import InvoicesList from './InvoicesList';

export default themr('InvoicesList')(InvoicesList);
